<template>
    <div>
        <template v-if="downloading">
            <br/>
            <div class="alert alert-info text-lg-center">
                <spinner color="#000"></spinner>
                {{$t('sandoz.download_in_progress')}}
            </div>
        </template>
        <template v-else>
            <b-button v-b-modal.uploadGuideModal variant="primary" block id="overview-upload-button">
                <span class="file-upload-icon">&#x21EA;</span>
                <div>{{$t('sandoz.upload_statistics_file')}}</div>
            </b-button>
        </template>

        <b-modal ref="uploadGuideModal" id="uploadGuideModal" title="Upload Instructions" @hide="importedStats=null"
                 size="xl">

            <b-row>
                <b-col>
                    <h5>
                        <b-badge pill variant="primary">1</b-badge>
                        Request data
                    </h5>

                    <p>
                        Download the data release form: <a
                        href="/documents/DE_Apo_Arzt_Datenfreigabeblatt_Standard.xlsx">Standard</a> or <a
                        href="/documents/DE_Apo_Datenfreigabeblatt_T und R Produkte.xlsx">T&R</a>
                    </p>

                    <p>
                        Select the business type: <select v-model="uploadInstructionType">
                        <option value="APO">APO</option>
                        <option value="SD">SD</option>
                    </select>
                    </p>

                    <p v-if="uploadInstructionType != null">
                        Contact the person in charge at the whole seller. Ask for a sheet that contains the GTIN or
                        pharma code as well as the quantity. This information is mandatory for Sortalys.
                    </p>

                    <table v-if="uploadInstructionType == 'APO'">
                        <tbody>
                        <tr>
                            <td><strong>Amedis</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Anfrage Bezugsstatistik<br/>
                                AN: <a href="mailto:vid@amedis.ch">vid@amedis.ch</a> & CC: <a
                                href="mailto:nadja.jeggli@amedis.ch">nadja.jeggli@amedis.ch</a><br/>
                                062 737 97 37
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Galexis</strong></td>
                        </tr>
                        <tr>
                            <td>
                                <a href="mailto:apotheke-drogerie@galexis.com">apotheke-drogerie@galexis.com</a><br/>
                                058 851 74 21
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Voigt</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Stadler, Sonia<br/>
                                <a href="mailto:SStadler@voigt.ch">SStadler@voigt.ch</a><br/>
                                071 466 45 32<br/>
                                Je Bezugsstatistik wird 35.- verrechnet. Intern informiert
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Unione</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Fritz, Manuela<br/>
                                <a href="mailto:manuela.fritz@ufd.swiss">manuela.fritz@ufd.swiss</a><br/>
                                091 985 61 62
                            </td>
                        </tr>
                        <tr>
                            <td><strong>PharmaFocus</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Herr Weldin<br/>
                                <a href="mailto:sebastian.weldin@pharmafocus.ch">sebastian.weldin@pharmafocus.ch</a><br/>
                                058 59 59 426
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table v-if="uploadInstructionType == 'SD'">
                        <tbody>
                        <tr>
                            <td><strong>Apotheke zur Rose</strong></td>
                        </tr>
                        <tr>
                            <td>
                                <a href="mailto:praxisapotheke@zurrose.ch">praxisapotheke@zurrose.ch</a><br/>
                                052 724 00 20<br/>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Pharmapool</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Frau Schlegel<br/>
                                <a href="mailto:info@pharmapool.ch">info@pharmapool.ch</a><br/>
                                071 727 25 35
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Regiomed</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Schuler, Danny<br/>
                                <a href="mailto:d.schuler@regiomed.ch">d.schuler@regiomed.ch</a><br/>
                                079 288 54 50
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Leimapharm</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Roth, Jean<br/>
                                <a href="mailto:jean.roth@leimapharm.ch">jean.roth@leimapharm.ch</a><br/>
                                061 723 14 00 (Keine Direktnummer vorhanden)
                            </td>
                        </tr>
                        <tr>
                            <td><strong>&Auml;rztemedika</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Herr Sch&auml;ublin<br/>
                                <a href="mailto:schaeublin@aerztemedika.ch">schaeublin@aerztemedika.ch</a><br/>
                                061 903 10 25
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Brunner Pharma</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Gamma, Dinja<br/>
                                <a href="mailto:d.gamma@brunnerpharma.ch">d.gamma@brunnerpharma.ch</a> / <a
                                href="mailto:sekretariat@brunnerpharma.ch">sekretariat@brunnerpharma.ch</a>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Disposan</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Erismann, Hans-Peter<br/>
                                <a href="mailto:erismann@disposan.ch">erismann@disposan.ch</a><br/>
                                043 322 47 00
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Galexis</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Affolter, Rosmarie<br/>
                                <a href="mailto:rosmarie.affolter@galexis.com ">rosmarie.affolter@galexis.com </a><br/>
                                058 851 74 08
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Medicom</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Mueller, Tina<br/>
                                <a href="mailto:tina.mueller@medicom-pharma.ch">tina.mueller@medicom-pharma.ch</a><br/>
                                033 650 70 00 (Keine Direktnummer vorhanden)
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Optipharm</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Huber, Sibylle<br/>
                                <a href="mailto:sibylle.huber@optipharm.ch">sibylle.huber@optipharm.ch</a><br/>
                                031 720 14 14
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Spirig</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Tamara Moreno<br/>
                                <a href="mailto:tamara.moreno@spirig-healthcare.ch">tamara.moreno@spirig-healthcare.ch</a><br/>
                                062 388 85 31
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Schmied Oberdiessbach</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Markus Schmid / Susan Pfuch<br/>
                                <a href="mailto:info@aposchmid.ch">info@aposchmid.ch</a><br/>
                                031 770 22 22
                            </td>
                        </tr>
                        <tr>
                            <td><strong>X-Med</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Sarah Trun<br/>
                                <a href="mailto:sarah.truniger@xmed.ch">sarah.truniger@xmed.ch</a><br/>
                                055 225 41 70
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </b-col>
                <b-col>
                    <h5>
                        <b-badge pill variant="primary">2</b-badge>
                        Prepare data
                    </h5>

                    In order to get your stock analysis you have to upload the data as an Excel file.
                    The Excel file has to have a certain structure you can download here: <a
                    href="/documents/template.xlsx">Template</a>

                    <br/><br/>

                    The excel file needs to have at least the GTIN or the PhCode as well as the Quantity (Menge). The
                    PhCode is 7 characters long, sometimes less if it starts with a 0.
                    The GTIN is longer. Make sure you copy the right information in the right column. Here's an example:

                    <br/><br/>

                    <img src="/images/example-file.png" alt=""/>
                </b-col>
                <b-col>
                    <h5>
                        <b-badge pill variant="primary">3</b-badge>
                        Upload data
                    </h5>

                    <template v-if="uploading">
                        <br/>
                        <div class="alert alert-info text-lg-center">
                            <spinner color="#000"></spinner>
                            Upload in progress
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="importError">
                            <br/>
                            <div class="alert alert-danger" style="white-space: pre-wrap">{{ importError }}</div>
                        </template>

                        <template v-if="importedStats">
                            <template v-if="importWarnings">
                                <br/>
                                <div class="alert alert-warning" style="white-space: pre-wrap">{{
                                        importWarnings
                                    }}
                                </div>
                            </template>
                            <br/>
                            <div class="alert alert-success">
                                File <code>{{ importedStats.filename }}</code> has been imported.
                            </div>
                        </template>

                        <template v-else>
                            When ready click the button below and select your Excel file:
                            <br/>
                            <br/>

                            <file-upload ref="fileSelector" accept=".xlsx" @file-selected="fileSelected"
                                         btn-label="Upload Statistics File"></file-upload>
                        </template>
                    </template>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal ref="uploadModal" title="Enter statistics data" size="xl" @ok="upload">
            <div class="d-block text-center">
                <b-form-group id="fieldsetHorizontal" label-cols-sm="4" label-cols-lg="3" label="File"
                              label-for="fileDescriptor" label-align="right">
                    <b-form-input id="fileDescriptor" readonly v-model="fileDescriptor"/>
                </b-form-group>

                <hr/>

                <b-form-group id="fieldsetTestUpload" label-cols-sm="4" label-cols-lg="3" label="Test-Upload"
                              label-for="testUpload" label-align="right" class="text-left">
                    <b-form-checkbox id="testUpload" v-model="testUpload" class="mt-2"> Test-Upload, I'd like to enter
                        the External ID and customer name manually
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group id="fieldsetCustomerSearch" label-cols-sm="4" label-cols-lg="3" label="Search"
                              label-for="customerSearch" label-align="right" v-if="!testUpload">
                    <b-input-group>
                        <b-form-input id="customerSearch" v-model="customerSearch" maxlength="255"
                                      placeholder="Name, external ID or address.."/>
                        <b-input-group-append>
                            <b-button class="py-0" variant="primary" @click="searchCustomer">Search</b-button>
                        </b-input-group-append>
                    </b-input-group>

                    <template v-if="searched">
                        <table class="table" v-if="customerSearchResult.length > 0">
                            <tr v-for="result in customerSearchResult">
                                <td align="left">{{ result.external_id }}</td>
                                <td align="left">{{ result.full_name }}</td>
                                <td align="left">{{ result.zip_code }} {{ result.address }}</td>
                                <td align="right" class="pr-0">
                                    <b-button size="sm" class="py-0" @click="selectCustomer(result)">&gt;</b-button>
                                </td>
                            </tr>
                        </table>
                        <div v-else>
                            Nothing found..
                        </div>
                    </template>

                </b-form-group>

                <b-form-group id="fieldsetCustomerExternalId" label-cols-sm="4" label-cols-lg="3" label="External ID"
                              label-for="customerExternalId" label-align="right"
                              v-if="testUpload || customerExternalId">
                    <b-form-input id="customerExternalId" v-model="customerExternalId" maxlength="255"
                                  placeholder="for example Z_0113484" :readonly="!testUpload"/>
                </b-form-group>
                <b-form-group id="fieldsetCustomerName" label-cols-sm="4" label-cols-lg="3" label="Customer Name"
                              label-for="customerName" label-align="right" v-if="testUpload || customerExternalId">
                    <b-form-input id="customerName" v-model="customerName" maxlength="255"/>
                </b-form-group>

                <hr/>

                <b-form-group id="fieldsetTimeInformation" label-cols-sm="4" label-cols-lg="3" label="Time Information"
                              label-for="timeInformation" label-align="right">
                    <b-row>
                        <b-col sm="auto">
                            <b-form-select id="timeYearFrom" v-model="timeYearFrom" :options="years"/>
                        </b-col>
                        <b-col>
                            <b-form-select id="timeMonthFrom" v-model="timeMonthFrom" :options="months"/>
                        </b-col>
                        <b-col class="text-center" sm="auto">
                            <div class="pt-1">to</div>
                        </b-col>
                        <b-col sm="auto">
                            <b-form-select id="timeYearTo" v-model="timeYearTo" :options="years"/>
                        </b-col>
                        <b-col>
                            <b-form-select id="timeMonthTo" v-model="timeMonthTo" :options="months"/>
                        </b-col>
                    </b-row>
                </b-form-group>
                <b-form-group id="fieldsetUser" label-cols-sm="4" label-cols-lg="3" label="Sales representative"
                              label-for="user" label-align="right">
                    <b-form-input id="user" v-model="user" type="text" maxlength="255"/>
                </b-form-group>
                <b-form-group id="fieldsetImage" label-cols-sm="4" label-cols-lg="3" label="Header Image"
                              label-for="headerImage" label-align="right">
                    <b-form-select id="headerImage" v-model="headerImageId" :options="templateImages" type="text"
                                   value-field="id" text-field="name"/>
                </b-form-group>
                <b-form-group id="fieldsetComment" label-cols-sm="4" label-cols-lg="3" label="Comment"
                              label-for="comment" label-align="right">
                    <b-form-textarea id="comment" v-model="comment" rows="3"/>
                </b-form-group>
            </div>

             <template #modal-footer="{ cancel, ok }">
                <b class="text-danger" v-if="uploadError">{{uploadError}}</b>
                <b-button @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="primary" @click="ok()">
                    Upload
                </b-button>
            </template>
        </b-modal>

        <b-modal ref="editModal" title="Edit statistic" size="lg" @ok="updateStatistic">
            <b-form-group id="fieldsetCustomerExternalId" label-cols-sm="4" label-cols-lg="3" label="External ID"
                          label-for="customerExternalId" label-align="right">
                <b-form-input id="customerExternalId" v-model="customerExternalId" maxlength="255"
                              placeholder="for example Z_0113484"/>
            </b-form-group>
            <b-form-group id="fieldsetCustomerName" label-cols-sm="4" label-cols-lg="3" label="Customer Name"
                          label-for="customerName" label-align="right">
                <b-form-input id="customerName" v-model="customerName" maxlength="255"/>
            </b-form-group>
            <b-form-group id="fieldsetTimeInformation" label-cols-sm="4" label-cols-lg="3" label="Time Information"
                          label-for="timeInformation" label-align="right">
                <b-row>
                    <b-col sm="auto">
                        <b-form-select id="timeYearFrom" v-model="timeYearFrom" :options="years"/>
                    </b-col>
                    <b-col>
                        <b-form-select id="timeMonthFrom" v-model="timeMonthFrom" :options="months"/>
                    </b-col>
                    <b-col class="text-center" sm="auto">
                        <div class="pt-1">to</div>
                    </b-col>
                    <b-col sm="auto">
                        <b-form-select id="timeYearTo" v-model="timeYearTo" :options="years"/>
                    </b-col>
                    <b-col>
                        <b-form-select id="timeMonthTo" v-model="timeMonthTo" :options="months"/>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group id="fieldsetImage" label-cols-sm="4" label-cols-lg="3" label="Header Image"
                          label-for="headerImage"
                          label-align="right">
                <b-form-select id="headerImage" v-model="headerImageId" :options="templateImages" type="text"
                               value-field="id"
                               text-field="name"/>
            </b-form-group>
            <b-form-group id="fieldsetComment" label-cols-sm="4" label-cols-lg="3" label="Comment" label-for="comment"
                          label-align="right">
                <b-form-textarea id="comment" v-model="comment" rows="3"/>
            </b-form-group>
        </b-modal>

        <o-table ref="tableList" :enable-delete="false"
                 :enable-new="false" :enable-view="false" :enable-edit="false" :title="$t('sandoz.range_analysis')"
                 :url="'/api/range_analysis'"
                 default-sort-by-direction="desc" default-sort-by="ImportDate">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
                    <o-filter-text :title="$t('sandoz.customer_external_id')"
                                   column="CustomerExternalId"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.customer_name')" column="CustomerName"></o-filter-text>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="ImportDate">{{ $t('sandoz.date') }}</o-table-header>
                <o-table-header column="CustomerExternalId">{{ $t('sandoz.customer_external_id') }}</o-table-header>
                <o-table-header column="CustomerName">{{ $t('sandoz.customer_name') }}</o-table-header>
                <o-table-header column="Comment">{{ $t('sandoz.comment') }}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{ props.item.ImportDate | formatDate }}</td>
                <td>{{ props.item.CustomerExternalId }}</td>
                <td>{{ props.item.CustomerName }}</td>
                <td>{{ props.item.Comment }}</td>
            </template>
            <template slot="body-controls" slot-scope="props">
                <td class="text-right">
                    <b-dropdown split @click="openStat(props.item)" class="m-2">
                        <template slot="button-content">
                            <fa icon="arrow-right"/>
                        </template>
                        <b-dropdown-item href="#" @click="deleteStat(props.item)">{{$t('sandoz.delete')}}</b-dropdown-item>
                        <b-dropdown-item href="#" @click="editStat(props.item)">{{$t('sandoz.edit')}}</b-dropdown-item>
                    </b-dropdown>
                </td>
            </template>
        </o-table>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import axios from 'axios'
import FileUpload from '../../components/sandoz/fileupload/v-file-upload'
import Spinner from '../../components/sandoz/Spinner'

Vue.use(FileUpload)

export default {
    data: () => ({
        downloading: false,
        uploading: false,
        importError: null,
        importWarnings: null,
        importedStats: null,
        selectedFile: null,
        uploadInstructionType: null,
        headerImageId: 1,
        timeYearFrom: null,
        timeYearTo: null,
        timeMonthFrom: null,
        timeMonthTo: null,
        customerExternalId: '',
        customer: '',
        customerName: '',
        comment: '',
        templateImages: [],
        customerSearch: '',
        customerSearchResult: [],
        user: '',
        years: [],
        months: [],
        searched: false,
        testUpload: false,
        uploadError: ''
    }),

    computed: {
        ...mapGetters({
            authUser: 'auth/user'
        }),
        fileDescriptor() {
            if (this.selectedFile === null) {
                return ''
            }
            return `${this.selectedFile.name} (${this.selectedFile.size} Bytes)`
        }
    },

    mounted() {
        this.user = this.authUser.name
        this.loadTemplateImages()
        this.initializeTimeInformation()
    },

    components: {
        Spinner
    },

    methods: {
        loadTemplateImages() {
            this.templateImages = [
                {id: 1, name: 'Lab', fileName: 'Public\\Images\\lab.jpg'},
                {id: 2, name: 'Pharmacist', fileName: 'Public\\Images\\pharmacist.jpg'},
                {id: 3, name: 'Scientists', fileName: 'Public\\Images\\scientists.jpg'},
                {id: 4, name: 'Stethoscope', fileName: 'Public\\Images\\stethoscope.jpg'}
            ]
        },
        initializeTimeInformation() {
            var currentDate = new Date()
            var currentYear = currentDate.getFullYear()
            this.years = []
            for (var iterationYear = 2018; iterationYear <= currentYear; iterationYear++) {
                this.years.push(iterationYear)
            }
            this.timeYearFrom = currentYear - 1
            this.timeYearTo = currentYear - 1
            this.timeMonthFrom = 1
            this.timeMonthTo = 12
            this.months = {
                1: this.$t('sandoz.january'),
                2: this.$t('sandoz.february'),
                3: this.$t('sandoz.march'),
                4: this.$t('sandoz.april'),
                5: this.$t('sandoz.may'),
                6: this.$t('sandoz.june'),
                7: this.$t('sandoz.july'),
                8: this.$t('sandoz.august'),
                9: this.$t('sandoz.september'),
                10: this.$t('sandoz.october'),
                11: this.$t('sandoz.november'),
                12: this.$t('sandoz.december')
            }
        },

        openStat(statistic) {
            window.open('https://www.sortalys.ch/dashboard/' + statistic.DirectLinkId)
        },

        updateStatistic() {
            var formData = {
                customer: this.customer,
                customerExternalId: this.customerExternalId,
                customerName: this.customerName,
                timeYearFrom: this.timeYearFrom,
                timeYearTo: this.timeYearTo,
                timeMonthFrom: this.timeMonthFrom,
                timeMonthTo: this.timeMonthTo,
                comment: this.comment,
                headerImageId: this.headerImageId
            }
            var self = this
            axios.post('/api/range_analysis/' + this.currentEditStatistic.BezugsStatistikID, formData).then((response) => {
                self.$refs.editModal.hide()
            }).catch((error) => {

            })
        },

        editStat(statistic) {
            this.currentEditStatistic = statistic
            this.customer = statistic.Customer
            this.customerName = statistic.CustomerName
            this.customerExternalId = statistic.CustomerExternalId
            this.headerImageId = statistic.HeaderImageId
            this.comment = statistic.Comment
            this.$refs.editModal.show()
        },

        deleteStat(statistic) {
            var my = this
            axios({
                method: 'DELETE',
                url: '/api/range_analysis/' + statistic.BezugsStatistikID
            }).then((response) => {
                my.$notify({
                    title: 'Deleted',
                    text: 'range analysis deleted'
                })

                my.$refs.tableList.search()
            }).catch((error) => {
                if (error.response.data && error.response.data.message) {
                    my.downloadError = error.response.data.message
                } else {
                    my.downloadError = error.message || error.toString()
                    console.log(error)
                }
            })
        },

        searchCustomer() {
            var my = this
            axios({
                method: 'GET',
                url: '/api/sandoz/org_contacts',
                params: {q: this.customerSearch}
            }).then((response) => {
                my.customerSearchResult = response.data.data
                my.searched = true
            }).catch((error) => {
                if (error.response.data && error.response.data.message) {
                    my.downloadError = error.response.data.message
                } else {
                    my.downloadError = error.message || error.toString()
                    console.log(error)
                }
            })
        },
        upload(evt) {
            evt.preventDefault()
            var my = this
            var formData = {
                fileName: my.selectedFile.name,
                file: my.selectedFileContent,
                customer: my.customer,
                customerExternalId: my.customerExternalId,
                customerName: my.customerName,
                timeYearFrom: my.timeYearFrom,
                timeYearTo: my.timeYearTo,
                timeMonthFrom: my.timeMonthFrom,
                timeMonthTo: my.timeMonthTo,
                user: my.user,
                uploaderEmail: my.authUser.email,
                comment: my.comment,
                headerImageId: my.headerImageId,
                testUpload: my.testUpload
            }

            if (this.customerExternalId == '' && !this.testUpload) {
                this.uploadError = 'Please select a customer using the search functionality'
                return false
            }
            else {
                this.uploadError = ''
            }

            this.$nextTick(() => {
                my.$refs.uploadModal.hide()
            })

            this.uploading = true
            axios.post('/api/range_analysis', formData)
                .then((response) => {
                    my.importWarnings = response.data.warnings
                    my.importedStats = response.data.bezugsStatistik
                    my.uploading = false
                    my.loadStatistics()
                })
                .catch((error) => {
                    if (error.response.data && error.response.data.message) {
                        my.importError = error.response.data.message;
                    } else {
                        my.importError = error.message || error.toString()
                        console.log(error)
                    }
                    my.uploading = false
                })
        },
        fileSelected(file) {
            this.importWarnings = this.importError = this.importedStats = null
            this.selectedFile = file

            var reader = new FileReader()
            reader.onload = (e) => {
                this.selectedFileContent = reader.result
                this.$refs.fileSelector.cleanInput()
            }
            reader.readAsDataURL(file)

            this.searched = false
            this.$refs.uploadModal.show()
        },
        selectCustomer(customer) {
            this.customerExternalId = customer.external_id
            this.customerName = customer.full_name
            this.customerSearchResult = []
            this.searched = false
            this.customerSearch = ''
        }
    }
}
</script>
